var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPencilLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7279 9.5758L14.3137 8.16158L5 17.4753V18.8895H6.41421L15.7279 9.5758ZM17.1421 8.16158L18.5563 6.74738L17.1421 5.33316L15.7279 6.74738L17.1421 8.16158ZM7.24264 20.8895H3V16.6468L16.435 3.21184C16.8256 2.82132 17.4587 2.82132 17.8492 3.21184L20.6777 6.04027C21.0682 6.43079 21.0682 7.06395 20.6777 7.45447L7.24264 20.8895Z",
    fill: "#1B1F1E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPencilLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pencil-line.e93db939.svg";
export { ForwardRef as ReactComponent };